/*
 * Zimma hero — auto-rotating product card stack.
 * Cards are stacked; one is "front", the neighbours sit rotated left/right,
 * the rest are hidden. Every few seconds the deck advances so each product
 * takes its turn at the front. Pauses on hover / focus / when the tab is hidden.
 */
(function () {
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initStack(stack) {
    if (!stack || stack.dataset.zimmaHeroReady === '1') return;
    stack.dataset.zimmaHeroReady = '1';

    var cards = Array.prototype.slice.call(stack.querySelectorAll('.zimma-hero__stack-card'));
    var n = cards.length;
    if (!n) return;

    var composition = stack.closest('.zimma-hero__composition') || stack.parentElement;
    var dots = composition
      ? Array.prototype.slice.call(composition.querySelectorAll('.zimma-hero__dot'))
      : [];

    var active = 0;
    var timer = null;
    var interval = Math.max(3, parseFloat(stack.dataset.interval) || 5) * 1000;

    function render() {
      for (var i = 0; i < n; i++) {
        var card = cards[i];
        var pos = (i - active + n) % n;
        card.classList.remove('is-front', 'is-left', 'is-right', 'is-hidden');
        if (pos === 0) {
          card.classList.add('is-front');
          card.removeAttribute('aria-hidden');
          card.removeAttribute('tabindex');
        } else {
          if (pos === 1 && n > 1) card.classList.add('is-right');
          else if (pos === n - 1 && n > 2) card.classList.add('is-left');
          else card.classList.add('is-hidden');
          card.setAttribute('aria-hidden', 'true');
          card.setAttribute('tabindex', '-1');
        }
      }
      for (var d = 0; d < dots.length; d++) {
        var on = d === active;
        dots[d].classList.toggle('is-active', on);
        dots[d].setAttribute('aria-selected', on ? 'true' : 'false');
      }
    }

    function go(i) {
      active = ((i % n) + n) % n;
      render();
    }

    function advance() {
      go(active + 1);
    }

    function start() {
      if (timer || REDUCED || n < 2) return;
      timer = window.setInterval(advance, interval);
    }

    function stop() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    function restart() {
      stop();
      start();
    }

    cards.forEach(function (card, i) {
      card.addEventListener('click', function (event) {
        // A click on a back card pulls it to the front instead of navigating.
        if (!card.classList.contains('is-front')) {
          event.preventDefault();
          go(i);
          restart();
        }
      });
    });

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        go(i);
        restart();
      });
    });

    if (composition) {
      composition.addEventListener('mouseenter', stop);
      composition.addEventListener('mouseleave', start);
    }
    stack.addEventListener('focusin', stop);
    stack.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else start();
    });

    stack.classList.add('is-ready');
    render();
    start();
  }

  function initAll(root) {
    (root || document)
      .querySelectorAll('[data-zimma-hero-stack]')
      .forEach(initStack);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  // Shopify theme editor re-renders the section on edit.
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
